export const samples = {
    'closed-hihat': [
        require('url:./../../assets/sounds/drum_samples/closed-hihat_1.mp3'),
        require('url:./../../assets/sounds/drum_samples/closed-hihat_2.mp3'),
        require('url:./../../assets/sounds/drum_samples/closed-hihat_3.mp3'),
        require('url:./../../assets/sounds/drum_samples/closed-hihat_4.mp3'),
        require('url:./../../assets/sounds/drum_samples/closed-hihat_5.mp3'),
        require('url:./../../assets/sounds/drum_samples/closed-hihat_6.mp3'),
        require('url:./../../assets/sounds/drum_samples/closed-hihat_7.mp3'),
        require('url:./../../assets/sounds/drum_samples/closed-hihat_8.mp3'),
        require('url:./../../assets/sounds/drum_samples/closed-hihat_9.mp3'),
        require('url:./../../assets/sounds/drum_samples/closed-hihat_10.mp3'),
        require('url:./../../assets/sounds/drum_samples/closed-hihat_11.mp3'),
        require('url:./../../assets/sounds/drum_samples/closed-hihat_12.mp3'),
    ],
    'open-hihat': [
        require('url:./../../assets/sounds/drum_samples/open-hihat_1.mp3'),
        require('url:./../../assets/sounds/drum_samples/open-hihat_2.mp3'),
        require('url:./../../assets/sounds/drum_samples/open-hihat_3.mp3'),
        require('url:./../../assets/sounds/drum_samples/open-hihat_4.mp3'),
        require('url:./../../assets/sounds/drum_samples/open-hihat_5.mp3'),
        require('url:./../../assets/sounds/drum_samples/open-hihat_6.mp3'),
        require('url:./../../assets/sounds/drum_samples/open-hihat_7.mp3'),
        require('url:./../../assets/sounds/drum_samples/open-hihat_8.mp3'),
        require('url:./../../assets/sounds/drum_samples/open-hihat_9.mp3'),
        require('url:./../../assets/sounds/drum_samples/open-hihat_10.mp3'),
        require('url:./../../assets/sounds/drum_samples/open-hihat_11.mp3'),
        require('url:./../../assets/sounds/drum_samples/open-hihat_12.mp3'),
    ],
    'crash': [
        require('url:./../../assets/sounds/drum_samples/crash_1.mp3'),
        require('url:./../../assets/sounds/drum_samples/crash_2.mp3'),
        require('url:./../../assets/sounds/drum_samples/crash_3.mp3'),
        require('url:./../../assets/sounds/drum_samples/crash_4.mp3'),
        require('url:./../../assets/sounds/drum_samples/crash_5.mp3'),
        require('url:./../../assets/sounds/drum_samples/crash_6.mp3'),
        require('url:./../../assets/sounds/drum_samples/crash_7.mp3'),
        require('url:./../../assets/sounds/drum_samples/crash_8.mp3'),
        require('url:./../../assets/sounds/drum_samples/crash_9.mp3'),
        require('url:./../../assets/sounds/drum_samples/crash_10.mp3'),
        require('url:./../../assets/sounds/drum_samples/crash_11.mp3'),
        require('url:./../../assets/sounds/drum_samples/crash_12.mp3'),
    ],
    'ride': [
        require('url:./../../assets/sounds/drum_samples/ride_1.mp3'),
        require('url:./../../assets/sounds/drum_samples/ride_2.mp3'),
        require('url:./../../assets/sounds/drum_samples/ride_3.mp3'),
        require('url:./../../assets/sounds/drum_samples/ride_4.mp3'),
        require('url:./../../assets/sounds/drum_samples/ride_5.mp3'),
        require('url:./../../assets/sounds/drum_samples/ride_6.mp3'),
        require('url:./../../assets/sounds/drum_samples/ride_7.mp3'),
        require('url:./../../assets/sounds/drum_samples/ride_8.mp3'),
        require('url:./../../assets/sounds/drum_samples/ride_9.mp3'),
        require('url:./../../assets/sounds/drum_samples/ride_10.mp3'),
        require('url:./../../assets/sounds/drum_samples/ride_11.mp3'),
        require('url:./../../assets/sounds/drum_samples/ride_12.mp3'),
    ],
    'kick': [
        require('url:./../../assets/sounds/drum_samples/kick_1.mp3'),
        require('url:./../../assets/sounds/drum_samples/kick_2.mp3'),
        require('url:./../../assets/sounds/drum_samples/kick_3.mp3'),
        require('url:./../../assets/sounds/drum_samples/kick_4.mp3'),
        require('url:./../../assets/sounds/drum_samples/kick_5.mp3'),
        require('url:./../../assets/sounds/drum_samples/kick_6.mp3'),
        require('url:./../../assets/sounds/drum_samples/kick_7.mp3'),
        require('url:./../../assets/sounds/drum_samples/kick_8.mp3'),
        require('url:./../../assets/sounds/drum_samples/kick_9.mp3'),
        require('url:./../../assets/sounds/drum_samples/kick_10.mp3'),
        require('url:./../../assets/sounds/drum_samples/kick_11.mp3'),
        require('url:./../../assets/sounds/drum_samples/kick_12.mp3'),
    ],
    'snare': [
        require('url:./../../assets/sounds/drum_samples/snare_1.mp3'),
        require('url:./../../assets/sounds/drum_samples/snare_2.mp3'),
        require('url:./../../assets/sounds/drum_samples/snare_3.mp3'),
        require('url:./../../assets/sounds/drum_samples/snare_4.mp3'),
        require('url:./../../assets/sounds/drum_samples/snare_5.mp3'),
        require('url:./../../assets/sounds/drum_samples/snare_6.mp3'),
        require('url:./../../assets/sounds/drum_samples/snare_7.mp3'),
        require('url:./../../assets/sounds/drum_samples/snare_8.mp3'),
        require('url:./../../assets/sounds/drum_samples/snare_9.mp3'),
        require('url:./../../assets/sounds/drum_samples/snare_10.mp3'),
        require('url:./../../assets/sounds/drum_samples/snare_11.mp3'),
        require('url:./../../assets/sounds/drum_samples/snare_12.mp3'),
    ],
    'hi-tom': [
        require('url:./../../assets/sounds/drum_samples/hi-tom_1.mp3'),
        require('url:./../../assets/sounds/drum_samples/hi-tom_2.mp3'),
        require('url:./../../assets/sounds/drum_samples/hi-tom_3.mp3'),
        require('url:./../../assets/sounds/drum_samples/hi-tom_4.mp3'),
        require('url:./../../assets/sounds/drum_samples/hi-tom_5.mp3'),
        require('url:./../../assets/sounds/drum_samples/hi-tom_6.mp3'),
        require('url:./../../assets/sounds/drum_samples/hi-tom_7.mp3'),
        require('url:./../../assets/sounds/drum_samples/hi-tom_8.mp3'),
        require('url:./../../assets/sounds/drum_samples/hi-tom_9.mp3'),
        require('url:./../../assets/sounds/drum_samples/hi-tom_10.mp3'),
        require('url:./../../assets/sounds/drum_samples/hi-tom_11.mp3'),
        require('url:./../../assets/sounds/drum_samples/hi-tom_12.mp3'),
    ],
    'mid-tom': [
        require('url:./../../assets/sounds/drum_samples/mid-tom_1.mp3'),
        require('url:./../../assets/sounds/drum_samples/mid-tom_2.mp3'),
        require('url:./../../assets/sounds/drum_samples/mid-tom_3.mp3'),
        require('url:./../../assets/sounds/drum_samples/mid-tom_4.mp3'),
        require('url:./../../assets/sounds/drum_samples/mid-tom_5.mp3'),
        require('url:./../../assets/sounds/drum_samples/mid-tom_6.mp3'),
        require('url:./../../assets/sounds/drum_samples/mid-tom_7.mp3'),
        require('url:./../../assets/sounds/drum_samples/mid-tom_8.mp3'),
        require('url:./../../assets/sounds/drum_samples/mid-tom_9.mp3'),
        require('url:./../../assets/sounds/drum_samples/mid-tom_10.mp3'),
        require('url:./../../assets/sounds/drum_samples/mid-tom_11.mp3'),
        require('url:./../../assets/sounds/drum_samples/mid-tom_12.mp3'),
    ],
    'floor-tom': [
      require('url:./../../assets/sounds/drum_samples/floor-tom_1.mp3'),
      require('url:./../../assets/sounds/drum_samples/floor-tom_2.mp3'),
      require('url:./../../assets/sounds/drum_samples/floor-tom_3.mp3'),
      require('url:./../../assets/sounds/drum_samples/floor-tom_4.mp3'),
      require('url:./../../assets/sounds/drum_samples/floor-tom_5.mp3'),
      require('url:./../../assets/sounds/drum_samples/floor-tom_6.mp3'),
      require('url:./../../assets/sounds/drum_samples/floor-tom_7.mp3'),
      require('url:./../../assets/sounds/drum_samples/floor-tom_8.mp3'),
      require('url:./../../assets/sounds/drum_samples/floor-tom_9.mp3'),
      require('url:./../../assets/sounds/drum_samples/floor-tom_10.mp3'),
      require('url:./../../assets/sounds/drum_samples/floor-tom_11.mp3'),
      require('url:./../../assets/sounds/drum_samples/floor-tom_12.mp3'),
    ],
  };